import { Box, CircularProgress, Collapse, Divider, IconButton, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchInput from "../inputs/searchInput";
import { useState, useContext } from "react";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import CityDropdown from "../dropdowns/cityDropdown";
import TypeDropdown from "../dropdowns/postRelated/typePostDropdown";
import PostStatusDropdown from "../dropdowns/postRelated/postStatusDropdown";
import StreetDropdown from "../dropdowns/streetDropdown";
import PageDropdown from "../dropdowns/pageDropdown";
import DriverDropdown from "../dropdowns/driverDropdown";
import TimeDropdown from "../dropdowns/timeDropdown";
import IsPagePaidDropdown from "../dropdowns/isPagePaidDropdown";
import IsDriverPaidDropdown from "../dropdowns/isDriverPaidDropdown";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import PdfDriverPostList from "../prints/pdfs/post/pdfDriverPostList";
import PdfPagePostList from "../prints/pdfs/post/pdfPagePostList";
import { AuthContext } from "../../provider/authProvider";
import BranchDropdown from "../dropdowns/branchDropdown";
import ChangeStatusDropdown from "../dropdowns/postRelated/changeStatusDropdown";
import IsDriverSetCheckbox from "../checkboxes/isDriverSetCheckbox";
import PdfMultiplePosts from "../prints/pdfs/post/pdfMultiplePosts";
import ExcelPostList from "../prints/excel/excelPostList";
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PostService from "../../services/postService";
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import CarCrashOutlinedIcon from '@mui/icons-material/CarCrashOutlined';


const PostFilter = ({
    handleSearchChange,
    searchTerm,
    selectedType,
    setSelectedType,
    selectedChangeStatus,
    setSelectedChangeStatus,
    selectedPostStatus,
    setSelectedPostStatus,
    resetFilter,
    selectedCity,
    setSelectedCity,
    selectedStreet,
    setSelectedStreet,
    selectedPage,
    setSelectedPage,
    selectedDriver,
    setSelectedDriver,
    showFilter,
    setShowFilter,
    selectedTime,
    setSelectedTime,
    selectedIsPagePaid,
    setSelectedIsPagePaid,
    selectedIsDriverPaid,
    setSelectedIsDriverPaid,
    selectedBranch,
    setSelectedBranch,
    ids,
    setIds,
    updateAll,
    sortState,
    selectedIsDriverSet,
    setSelectedIsDriverSet
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [id, setId] = useState('');
    const [loadingPrint, setLoadingPrint] = useState(false);

    const { user } = useContext(AuthContext);
    const userPermissions = user?.permissions || [];
    const allBranchPermission = userPermissions?.some(p => p.value === 'allBranches');

    const handlePrint = async (filters) => {
        try {
            setLoadingPrint(true);
            const response = await PostService.sendPostToPrintMultiple(filters);
            console.log(response);
        } catch (error) {
            console.error('Error sending post:', error);
        } finally {
            setLoadingPrint(false);
        }
    };

    const handleAddInvoice = (e) => {
        const value = e.target.value;
        setId(value);

        if (e.key === 'Enter' && value.trim() !== '') {
            setIds([...ids, value.trim()]);
            setId('');
        }
    };

    const handleRemoveInvoice = (indexToRemove) => {
        const updatedNumbers = ids.filter((_, index) => index !== indexToRemove);
        setIds(updatedNumbers);
    };


    const toggleShowFilter = () => {
        setShowFilter(!showFilter);
    };

    const handleType = (type) => {
        if (type === t("new")) return "new";
        else if (type === t("change")) return "change";
    };

    const handleChangeStatus = (status) => {
        if (status === t("driver")) return "driver";
        else if (status === t("inOffice")) return "inOffice";
        else if (status === t("returnToPage")) return "returnToPage";
    };

    return (
        <Box
            sx={{
                mb: 2,
                mt: 1,
                border: 1,
                borderColor: theme.palette.customGrey.borderInput,
                backgroundColor: 'white',
                borderRadius: 1,
            }}
        >
            {/* first filter row */}
            {
                isTablet ?
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 50,
                    }}>
                        <Box sx={{ px: 0.6 }}>
                            <FilterAltOutlinedIcon />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'56%'}>
                            <SearchInput placeholder={t('name')} onChange={handleSearchChange} value={searchTerm} />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: theme.palette.text.red,
                                cursor: 'pointer',
                                width: '15%'
                            }}
                            onClick={resetFilter}
                        >
                            <ReplayOutlinedIcon />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box sx={{
                               display: 'inline-flex',
                               alignItems: 'center',
                               justifyContent: 'center',
                            cursor: 'pointer',
                            width: '15%'
                        }}
                            onClick={toggleShowFilter}
                        >
                            {showFilter ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
                        </Box>
                    </Box>
                    :
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: 50,
                    }}>
                        <Box sx={{ px: 2 }}>
                            <FilterAltOutlinedIcon />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'20%'}>
                            <SearchInput placeholder={t('name')} onChange={handleSearchChange} value={searchTerm} />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'20%'}>
                            <TypeDropdown
                                isFilter={true}
                                selectedType={selectedType}
                                setSelectedType={setSelectedType}
                            />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'20%'}>
                            <PostStatusDropdown
                                isFilter={true}
                                selectedPostStatus={selectedPostStatus}
                                setSelectedPostStatus={setSelectedPostStatus}
                            />
                        </Box>
                        <Divider orientation="vertical" />
                        <Box width={'20%'}>
                            <ChangeStatusDropdown
                                isFilter={true}
                                selectedChangeStatus={selectedChangeStatus}
                                setSelectedChangeStatus={setSelectedChangeStatus}
                            />
                        </Box>
                        <Divider orientation="vertical" />

                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                color: theme.palette.text.red,
                                px: 2,
                                cursor: 'pointer',
                                width: '15%'
                            }}
                            onClick={resetFilter}
                        >
                            <ReplayOutlinedIcon />
                            <Box width={3}></Box>
                            <Typography variant="subtitle2">{t('resetFilter')}</Typography>
                        </Box>
                        <Divider orientation="vertical" />
                        <Box sx={{
                            px: 2,
                            cursor: 'pointer'
                        }}
                            onClick={toggleShowFilter}
                        >
                            {showFilter ? <KeyboardArrowUpOutlinedIcon /> : <KeyboardArrowDownOutlinedIcon />}
                        </Box>
                    </Box>
            }

            {/* expanded filter box row  */}
            <Collapse in={showFilter}>
                <Divider />
                {/* row 2 */}
                <Box
                    sx={{
                        display: isTablet ? 'unset' : 'flex',
                        alignItems: 'center',
                        height: isTablet ? 300 : 50,
                    }}
                >
                    {
                        isTablet && <Box>
                            <Box width={'100%'}>
                                <TypeDropdown
                                    isFilter={true}
                                    selectedType={selectedType}
                                    setSelectedType={setSelectedType}
                                />
                            </Box>
                            <Divider />
                            <Box width={'100%'}>
                                <PostStatusDropdown
                                    isFilter={true}
                                    selectedPostStatus={selectedPostStatus}
                                    setSelectedPostStatus={setSelectedPostStatus}
                                />
                            </Box>
                            <Divider />
                            <Box width={'100%'}>
                                <ChangeStatusDropdown
                                    isFilter={true}
                                    selectedChangeStatus={selectedChangeStatus}
                                    setSelectedChangeStatus={setSelectedChangeStatus}
                                />
                            </Box>
                            <Divider />
                        </Box>
                    }
                    {allBranchPermission && <Box width={isTablet ? "100%" : "20%"}>
                        <BranchDropdown
                            isFilter
                            selectedBranch={selectedBranch}
                            setSelectedBranch={setSelectedBranch}
                        />
                    </Box>}
                    {allBranchPermission && <Divider orientation={isTablet ? "horizontal" : "vertical"} />}
                    <Box width={isTablet ? "100%" : (allBranchPermission ? "20%" : '25%')}>
                        <CityDropdown
                            isFilter
                            selectedCity={selectedCity}
                            setSelectedCity={setSelectedCity}
                        />
                    </Box>
                    <Divider orientation={isTablet ? "horizontal" : "vertical"} />
                    <Box width={isTablet ? "100%" : (allBranchPermission ? "20%" : '25%')}>
                        <StreetDropdown
                            isFilter
                            selectedStreet={selectedStreet}
                            setSelectedStreet={setSelectedStreet}
                        />
                    </Box>
                    <Divider orientation={isTablet ? "horizontal" : "vertical"} />
                    <Box width={isTablet ? "100%" : (allBranchPermission ? "20%" : '25%')}>
                        <PageDropdown
                            isFilter
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                    </Box>
                    <Divider orientation={isTablet ? "horizontal" : "vertical"} />
                    <Box width={isTablet ? "100%" : (allBranchPermission ? "20%" : '25%')}>
                        <DriverDropdown
                            isFilter
                            selectedDriver={selectedDriver}
                            setSelectedDriver={setSelectedDriver}
                        />
                    </Box>
                </Box>

                <Divider />

                {/* row 3 */}
                <Box
                    sx={{
                        display: isTablet ? 'unset' : 'flex',
                        alignItems: 'center',
                        height: isTablet ? 150 : 50,
                    }}
                >

                    <Box sx={{ alignContent: 'center', height: 50, width: isTablet ? '100%' : '50%' }}>
                        <TimeDropdown
                            isFilter={true}
                            selectedTime={selectedTime}
                            setSelectedTime={setSelectedTime}
                        />
                    </Box>
                    <Divider orientation={isTablet ? "horizontal" : "vertical"} />

                    <Box width={isTablet ? "100%" : "25%"}>
                        <IsPagePaidDropdown
                            isFilter
                            selectedIsPagePaid={selectedIsPagePaid}
                            setSelectedIsPagePaid={setSelectedIsPagePaid}
                        />
                    </Box>
                    <Divider orientation={isTablet ? "horizontal" : "vertical"} />

                    <Box width={isTablet ? "100%" : "25%"}>
                        <IsDriverPaidDropdown
                            isFilter
                            selectedIsDriverPaid={selectedIsDriverPaid}
                            setSelectedIsDriverPaid={setSelectedIsDriverPaid}
                        />
                    </Box>
                </Box>
                <Divider />

                {/* row 4 */}
                {
                    // samll screen
                    isTablet ? <Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 50,
                        }}>
                            <Box width={'30%'}>
                                <TextField
                                    placeholder={t('id')}
                                    type='text'
                                    variant="standard"
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                    value={id}
                                    sx={{
                                        px: 1,
                                        width: '100%'
                                    }}
                                    onKeyDown={(e) => handleAddInvoice(e)}
                                    onChange={(e) => setId(e.target.value)}
                                />
                            </Box>
                            <Divider orientation={"vertical"} />
                            <Box sx={{
                                display: 'flex',
                                width: '70%',
                                overflowX: 'scroll',
                                height: 50
                            }}>
                                {ids.map((number, index) => (
                                    <Box
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            px: 1,
                                        }} key={index}
                                    >
                                        <Typography variant="subtitle2">{number}</Typography>
                                        <CloseOutlinedIcon
                                            sx={{
                                                color: theme.palette.text.red,
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleRemoveInvoice(index)}
                                        />

                                    </Box>
                                ))}
                            </Box>
                        </Box>

                        <Divider />

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 50,
                        }}>
                            <Box width={"50%"}>
                                <IsDriverSetCheckbox
                                    isFilter
                                    selectedIsDriverSet={selectedIsDriverSet}
                                    setSelectedIsDriverSet={setSelectedIsDriverSet}
                                />
                            </Box>
                            <Divider orientation={"vertical"} />
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-evenly',
                                alignItems: 'space-between',
                                width: '50%',
                                height: '100%'
                            }}>
                                 <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.main,
                                        // px: 0.5,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => updateAll({ type: 'postStatus' })}
                                >
                                    <DriveFileRenameOutlineOutlinedIcon />
                                    {/* <Box width={3}></Box>
                                    <Typography variant="subtitle2">{t('updateAll')}</Typography> */}
                                </Box>

                                <Divider orientation={"vertical"} />

                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.main,
                                        // px: 2,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => updateAll({ type: 'driver' })}
                                >
                                    <CarCrashOutlinedIcon />
                                </Box>

                                <Divider orientation={"vertical"} />

                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.main,
                                        // px: 2,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => updateAll({ type: 'changeStatus' })}
                                >
                                    <ChangeCircleOutlinedIcon />
                                </Box>

                            </Box>
                        </Box>

                        <Divider />


                        <Box sx={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                            height: 50
                        }}>
                            <IconButton color="primary" disabled={selectedDriver ? false : true}>
                                <PdfDriverPostList
                                    data={{
                                        name: searchTerm,
                                        streetId: selectedStreet && selectedStreet.id,
                                        cityId: selectedCity && selectedCity.id,
                                        driverId: selectedDriver && selectedDriver.id,
                                        branch: selectedBranch,
                                        pageId: selectedPage && selectedPage.id,
                                        postStatusId: selectedPostStatus && selectedPostStatus.id,
                                        type: handleType(selectedType),
                                        isPagePaid: selectedIsPagePaid,
                                        isDriverPaid: selectedIsDriverPaid,
                                        time: selectedTime,
                                        sort: sortState,
                                        ids: JSON.stringify(ids),
                                    }} />
                            </IconButton>

                            <IconButton color="primary" disabled={selectedDriver ? false : true}>
                                <ExcelPostList
                                    type="driver"
                                    data={{
                                        name: searchTerm,
                                        streetId: selectedStreet && selectedStreet.id,
                                        cityId: selectedCity && selectedCity.id,
                                        driverId: selectedDriver && selectedDriver.id,
                                        branch: selectedBranch,
                                        pageId: selectedPage && selectedPage.id,
                                        postStatusId: selectedPostStatus && selectedPostStatus.id,
                                        type: handleType(selectedType),
                                        isPagePaid: selectedIsPagePaid,
                                        isDriverPaid: selectedIsDriverPaid,
                                        time: selectedTime,
                                        sort: sortState,
                                        ids: JSON.stringify(ids),
                                    }} />
                            </IconButton>

                            <Divider orientation={"vertical"} />

                            <IconButton color="primary" disabled={selectedPage ? false : true}>
                                <PdfPagePostList
                                    data={{
                                        name: searchTerm,
                                        streetId: selectedStreet && selectedStreet.id,
                                        cityId: selectedCity && selectedCity.id,
                                        driverId: selectedDriver && selectedDriver.id,
                                        branch: selectedBranch,
                                        pageId: selectedPage && selectedPage.id,
                                        postStatusId: selectedPostStatus && selectedPostStatus.id,
                                        type: handleType(selectedType),
                                        isPagePaid: selectedIsPagePaid,
                                        isDriverPaid: selectedIsDriverPaid,
                                        time: selectedTime,
                                        sort: sortState,
                                        ids: JSON.stringify(ids),
                                    }} />
                            </IconButton>

                            <IconButton color="primary" disabled={selectedPage ? false : true}>
                                <ExcelPostList
                                    type="page"
                                    data={{
                                        name: searchTerm,
                                        streetId: selectedStreet && selectedStreet.id,
                                        cityId: selectedCity && selectedCity.id,
                                        driverId: selectedDriver && selectedDriver.id,
                                        branch: selectedBranch,
                                        pageId: selectedPage && selectedPage.id,
                                        postStatusId: selectedPostStatus && selectedPostStatus.id,
                                        type: handleType(selectedType),
                                        isPagePaid: selectedIsPagePaid,
                                        isDriverPaid: selectedIsDriverPaid,
                                        time: selectedTime,
                                        sort: sortState,
                                        ids: JSON.stringify(ids),
                                    }} />
                            </IconButton>

                            <Divider orientation={"vertical"} />

                            <Box sx={{
                                px: 1.2,
                                pt: 0.6,
                                cursor: 'pointer',
                                pointerEvents: 'auto',
                                opacity: 1,
                            }}>
                                <PdfMultiplePosts
                                    filters={{
                                        name: searchTerm,
                                        streetId: selectedStreet?.id,
                                        cityId: selectedCity?.id,
                                        driverId: selectedDriver?.id,
                                        branchId: selectedBranch?.id,
                                        pageId: selectedPage?.id,
                                        postStatusId: selectedPostStatus?.id,
                                        type: handleType(selectedType),
                                        changeStatus: handleChangeStatus(selectedChangeStatus),
                                        isPagePaid: selectedIsPagePaid,
                                        isDriverPaid: selectedIsDriverPaid,
                                        ids: JSON.stringify(ids),
                                        ...selectedTime,
                                        ...sortState
                                    }}
                                />
                            </Box>

                            <Divider orientation={"vertical"} />
                            <Box sx={{
                                px: 1.2,
                                pt: 0.6,
                                pb: 0.25,
                                cursor: 'pointer'
                            }} onClick={() => handlePrint({
                                name: searchTerm,
                                streetId: selectedStreet?.id,
                                cityId: selectedCity?.id,
                                driverId: selectedDriver?.id,
                                branchId: selectedBranch?.id,
                                pageId: selectedPage?.id,
                                postStatusId: selectedPostStatus?.id,
                                type: handleType(selectedType),
                                changeStatus: handleChangeStatus(selectedChangeStatus),
                                isPagePaid: selectedIsPagePaid,
                                isDriverPaid: selectedIsDriverPaid,
                                ids: JSON.stringify(ids),
                                ...selectedTime,
                                ...sortState
                            })}>
                                {loadingPrint ? <CircularProgress color="primary" size={20} />
                                    : <LocalPrintshopOutlinedIcon fontSize='small'
                                        sx={{ color: theme.palette.text.primary }} />}
                            </Box>
                        </Box>


                    </Box> :
                        // large screen
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                height: 50,
                            }}
                        >

                            <Box width={isTablet ? '23%' : '18%'}>
                                <TextField
                                    placeholder={t('id')}
                                    type='text'
                                    variant="standard"
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                    value={id}
                                    sx={{
                                        px: 1,
                                        width: '100%'
                                    }}
                                    onKeyDown={(e) => handleAddInvoice(e)}
                                    onChange={(e) => setId(e.target.value)}
                                />
                            </Box>
                            <Divider orientation={"vertical"} />
                            <Box sx={{
                                display: 'flex',
                                width: isTablet ? '42%' : '40%',
                                overflowX: 'scroll',
                                height: 50
                            }}>
                                {ids.map((number, index) => (
                                    <Box
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            px: 1,
                                        }} key={index}
                                    >
                                        <Typography variant="subtitle2">{number}</Typography>
                                        <CloseOutlinedIcon
                                            sx={{
                                                color: theme.palette.text.red,
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => handleRemoveInvoice(index)}
                                        />

                                    </Box>
                                ))}
                            </Box>
                            <Divider orientation={"vertical"} />

                            <Box width={isTablet ? "10%" : "12%"}>
                                <IsDriverSetCheckbox
                                    isFilter
                                    selectedIsDriverSet={selectedIsDriverSet}
                                    setSelectedIsDriverSet={setSelectedIsDriverSet}
                                />
                            </Box>
                            <Divider orientation={"vertical"} />
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-evenly',
                                alignItems: 'space-between',
                                width: isTablet ? '16%' : '13%',
                                height: '100%'
                            }}>
                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.main,
                                        // px: 0.5,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => updateAll({ type: 'postStatus' })}
                                >
                                    <DriveFileRenameOutlineOutlinedIcon />
                                    {/* <Box width={3}></Box>
                                    <Typography variant="subtitle2">{t('updateAll')}</Typography> */}
                                </Box>

                                <Divider orientation={"vertical"} />

                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.main,
                                        // px: 2,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => updateAll({ type: 'driver' })}
                                >
                                    <CarCrashOutlinedIcon />
                                </Box>

                                <Divider orientation={"vertical"} />

                                <Box
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: theme.palette.primary.main,
                                        // px: 2,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => updateAll({ type: 'changeStatus' })}
                                >
                                    <ChangeCircleOutlinedIcon />
                                </Box>

                            </Box>

                            <Divider orientation={"vertical"} />

                            <Box sx={{
                                display: 'flex',
                                width: isTablet ? '19%' : '17%',
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                                height: 50
                            }}>
                                <IconButton color="primary" disabled={selectedDriver ? false : true}>
                                    <PdfDriverPostList
                                        data={{
                                            name: searchTerm,
                                            streetId: selectedStreet && selectedStreet.id,
                                            cityId: selectedCity && selectedCity.id,
                                            driverId: selectedDriver && selectedDriver.id,
                                            branch: selectedBranch,
                                            pageId: selectedPage && selectedPage.id,
                                            postStatusId: selectedPostStatus && selectedPostStatus.id,
                                            type: handleType(selectedType),
                                            isPagePaid: selectedIsPagePaid,
                                            isDriverPaid: selectedIsDriverPaid,
                                            time: selectedTime,
                                            sort: sortState,
                                            ids: JSON.stringify(ids),
                                        }} />
                                </IconButton>

                                <IconButton color="primary" disabled={selectedDriver ? false : true}>
                                    <ExcelPostList
                                        type="driver"
                                        data={{
                                            name: searchTerm,
                                            streetId: selectedStreet && selectedStreet.id,
                                            cityId: selectedCity && selectedCity.id,
                                            driverId: selectedDriver && selectedDriver.id,
                                            branch: selectedBranch,
                                            pageId: selectedPage && selectedPage.id,
                                            postStatusId: selectedPostStatus && selectedPostStatus.id,
                                            type: handleType(selectedType),
                                            isPagePaid: selectedIsPagePaid,
                                            isDriverPaid: selectedIsDriverPaid,
                                            time: selectedTime,
                                            sort: sortState,
                                            ids: JSON.stringify(ids),
                                        }} />
                                </IconButton>

                                <Divider orientation={"vertical"} />

                                <IconButton color="primary" disabled={selectedPage ? false : true}>
                                    <PdfPagePostList
                                        data={{
                                            name: searchTerm,
                                            streetId: selectedStreet && selectedStreet.id,
                                            cityId: selectedCity && selectedCity.id,
                                            driverId: selectedDriver && selectedDriver.id,
                                            branch: selectedBranch,
                                            pageId: selectedPage && selectedPage.id,
                                            postStatusId: selectedPostStatus && selectedPostStatus.id,
                                            type: handleType(selectedType),
                                            isPagePaid: selectedIsPagePaid,
                                            isDriverPaid: selectedIsDriverPaid,
                                            time: selectedTime,
                                            sort: sortState,
                                            ids: JSON.stringify(ids),
                                        }} />
                                </IconButton>

                                <IconButton color="primary" disabled={selectedPage ? false : true}>
                                    <ExcelPostList
                                        type="page"
                                        data={{
                                            name: searchTerm,
                                            streetId: selectedStreet && selectedStreet.id,
                                            cityId: selectedCity && selectedCity.id,
                                            driverId: selectedDriver && selectedDriver.id,
                                            branch: selectedBranch,
                                            pageId: selectedPage && selectedPage.id,
                                            postStatusId: selectedPostStatus && selectedPostStatus.id,
                                            type: handleType(selectedType),
                                            isPagePaid: selectedIsPagePaid,
                                            isDriverPaid: selectedIsDriverPaid,
                                            time: selectedTime,
                                            sort: sortState,
                                            ids: JSON.stringify(ids),
                                        }} />
                                </IconButton>

                                <Divider orientation={"vertical"} />

                                <Box sx={{
                                    px: 1.2,
                                    pt: 0.6,
                                    cursor: 'pointer',
                                    pointerEvents: 'auto',
                                    opacity: 1,
                                }}>
                                    <PdfMultiplePosts
                                        filters={{
                                            name: searchTerm,
                                            streetId: selectedStreet?.id,
                                            cityId: selectedCity?.id,
                                            driverId: selectedDriver?.id,
                                            branchId: selectedBranch?.id,
                                            pageId: selectedPage?.id,
                                            postStatusId: selectedPostStatus?.id,
                                            type: handleType(selectedType),
                                            changeStatus: handleChangeStatus(selectedChangeStatus),
                                            isPagePaid: selectedIsPagePaid,
                                            isDriverPaid: selectedIsDriverPaid,
                                            ids: JSON.stringify(ids),
                                            ...selectedTime,
                                            ...sortState
                                        }}
                                    />
                                </Box>

                                <Divider orientation={"vertical"} />
                                <Box sx={{
                                    px: 1.2,
                                    pt: 0.6,
                                    pb: 0.25,
                                    cursor: 'pointer'
                                }} onClick={() => handlePrint({
                                    name: searchTerm,
                                    streetId: selectedStreet?.id,
                                    cityId: selectedCity?.id,
                                    driverId: selectedDriver?.id,
                                    branchId: selectedBranch?.id,
                                    pageId: selectedPage?.id,
                                    postStatusId: selectedPostStatus?.id,
                                    type: handleType(selectedType),
                                    changeStatus: handleChangeStatus(selectedChangeStatus),
                                    isPagePaid: selectedIsPagePaid,
                                    isDriverPaid: selectedIsDriverPaid,
                                    ids: JSON.stringify(ids),
                                    ...selectedTime,
                                    ...sortState
                                })}>
                                    {loadingPrint ? <CircularProgress color="primary" size={20} />
                                        : <LocalPrintshopOutlinedIcon fontSize='small'
                                            sx={{ color: theme.palette.text.primary }} />}
                                </Box>
                            </Box>


                        </Box>
                }
            </Collapse>
        </Box>
    );
}

export default PostFilter;